import { render, staticRenderFns } from "./VerifyLinkOtp.vue?vue&type=template&id=00f06420&"
import script from "./VerifyLinkOtp.vue?vue&type=script&lang=js&"
export * from "./VerifyLinkOtp.vue?vue&type=script&lang=js&"
import style0 from "./VerifyLinkOtp.vue?vue&type=style&index=0&id=00f06420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports